import { div, li, span, ul } from '../../../scripts/dom-builder.js';
import moveInstrumentation from '../../../scripts/utils/editor-support-utils.js';
import { getFactNumbers } from './utils/get-fact-numbers.js';

export default async function decorate(block) {
  const oddCount = block.childElementCount % 2 !== 0;
  const factsList = ul({
    class: `fast-facts__items ${oddCount ? 'odd-count' : 'even-count'}`,
  });
  [...block.children].forEach((row) => {
    const [numberPart, textPart, linkPart] = [...row.children];
    const { factMain, factUnit } = getFactNumbers(numberPart);
    const eyebrow = textPart.querySelector('h6')?.textContent || '';
    const headline = textPart.querySelector('h3')?.textContent || '';
    const textEls = textPart.querySelectorAll('p');
    const link = linkPart.querySelector('.button-container') || '';
    if (link) {
      link.classList.add('fast-facts__item__link');
    }

    const hasDetails = headline || textEls.length > 0 || eyebrow;

    const liEl = li(
      { class: 'fast-facts__item' },
      factMain
        ? div(
            { class: 'fast-facts__item__fact' },
            span({ class: 'fast-facts__item__fact-main' }, factMain),
            span({ class: 'fast-facts__item__fact-unit' }, factUnit),
          )
        : '',
      hasDetails
        ? div(
            { class: 'fast-facts__item__details' },
            eyebrow ? div({ class: 'fast-facts__item__eyebrow' }, eyebrow) : '',
            headline
              ? div({ class: 'fast-facts__item__headline' }, headline)
              : '',
            textEls.length > 0
              ? div({ class: 'fast-facts__item__text' }, ...textEls)
              : '',
          )
        : '',
      link,
    );

    moveInstrumentation(row, liEl);
    row.remove();
    factsList.append(liEl);
  });
  block.append(factsList);
}
